import { render, staticRenderFns } from "./GameReplay.vue?vue&type=template&id=40bb287d&scoped=true&"
import script from "./GameReplay.vue?vue&type=script&lang=js&"
export * from "./GameReplay.vue?vue&type=script&lang=js&"
import style0 from "./GameReplay.vue?vue&type=style&index=0&id=40bb287d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bb287d",
  null
  
)

export default component.exports